module.exports = __webpack_public_path__ + "img/diddy-kong-min.c265d3fc.png";